import { z } from "zod";
import { TAXONOMY_URN_PATTERN, type TaxonomyUrn } from "@shared/types/taxonomy.ts";

/** What narrows the Catalogue's subjects. It lives in the URL, so a link opens the same view. */
export const catalogueFiltersSchema = z.object({
  /** A health field URN: only the papers tagged with it are counted. */
  field: z
    .custom<TaxonomyUrn>((value) => typeof value === "string" && TAXONOMY_URN_PATTERN.test(value))
    .nullable()
    .default(null),
});

export type CatalogueFilters = z.output<typeof catalogueFiltersSchema>;
